import { AxiosRequestConfig } from 'axios';

const PROPERTY_CATALOG_ITEMS_PATH = /^\/v1\/catalogs\/[^/?]+(\?|$)/;

const hasSearchParams = (params: AxiosRequestConfig['params']): boolean => {
    if (!params || typeof params !== 'object') {
        return false;
    }

    const record = params as Record<string, unknown>;

    return Boolean(
        record.searchStr ??
            record.search_str ??
            record.searchString ??
            record.search_string,
    );
};

const hasCatalogItemsQueryParams = (
    params: AxiosRequestConfig['params'],
): boolean => {
    if (!params || typeof params !== 'object') {
        return false;
    }

    const record = params as Record<string, unknown>;

    return (
        hasSearchParams(params) ||
        Boolean(record.categoryId ?? record.category_id) ||
        Boolean(record.isInventory ?? record.is_inventory)
    );
};

const isGlobalCatalogSearchItemsUrl = (url: string): boolean =>
    url.includes('/catalogs/search-items');

const isPropertyCatalogItemsUrl = (url: string): boolean =>
    PROPERTY_CATALOG_ITEMS_PATH.test(url);

export const isCatalogSearchRequest = (config: AxiosRequestConfig): boolean => {
    const url = config.url;

    if (!url) {
        return false;
    }

    if (isGlobalCatalogSearchItemsUrl(url)) {
        return true;
    }

    if (isPropertyCatalogItemsUrl(url)) {
        return hasCatalogItemsQueryParams(config.params);
    }

    return false;
};
